import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "line-awesome/dist/line-awesome/css/line-awesome.min.css";
import "./assets/font_bottom_logo/iconfont.css";
import { Input, Select, Option, Loading, Button, Message, Icon, Rate, Checkbox } from 'element-ui';

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

// 设置语言
locale.use(lang)

import animated from 'animate.css'
Vue.use(animated)

import "./assets/common.scss";

// 跳转后返回顶部
router.afterEach((to) => {
  window.scrollTo(0, 0);
  gtag('event', 'page_view', {
    page_title: to.name,
    page_path: to.fullPath,
    page_location: window.location.href,
  })
});

Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Loading);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Rate);
Vue.use(Checkbox);
// Vue.component(Message)
Vue.prototype.$message = Message

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
